// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SearchSymbolsMob_searchWrapper__R4k5v","arrowBack":"SearchSymbolsMob_arrowBack__5BTDW","buttonsWapper":"SearchSymbolsMob_buttonsWapper__rNXqh"};